module.exports = __webpack_public_path__ + "img/strap length.5573f227.png";